// removed by extract-text-webpack-plugin
module.exports = {"CheckoutSummary":"CheckoutSummary__CheckoutSummary__1xBm4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/CheckoutSummary/CheckoutSummary.css
// module id = 135
// module chunks = 0